export enum FavoriteObjectEntity {
    SCHEMES = 'schemes',
    BOOKING_DEVICES = 'devices',
}

export type FavoriteObjectId = number;
